module.exports = __webpack_public_path__ + "static/media/pytorch.4ed75c15.svg";